'use strict';

const saStickyBar = [
  '$window',
  'throttle',

  function ($window, throttle) {
    var windowEl = angular.element($window);

    return {
      restrict: 'A',
      link: function ($scope, $element) {
        const barElement = angular.element($element.children()[0]);
        const setCSS = throttle(() => {
          const isFixed = isBarFixed();
          const height = barElement[0].offsetHeight;

          if (isFixed) {
            $element.css('height', String(height) + 'px');
          } else {
            $element.css('height', null);
          }
        }, 100);

        function isBarFixed() {
          return $window.getComputedStyle(barElement[0], null).getPropertyValue('position') === 'fixed';
        }

        windowEl.on('resize', setCSS);
        $element.on('$destroy', function () {
          windowEl.off('resize', setCSS);
        });

        setCSS();
      }
    };
  }
];

export default saStickyBar;



// WEBPACK FOOTER //
// ./app/src/directives/sticky_bar.js